<template>
  <div v-cloak v-if="template" class="item-common pt-10 pb-15 px-7">
    <div class="header">
      <h1 class="title">{{ $t('첨부파일') }}</h1>
      <v-divider></v-divider>
      <p class="desc" v-html="template.guideFile"></p>
    </div>
    <div class="body">
      <v-form ref="form">
        <template v-for="(item, i) in fileInfos">
          <v-row class="mt-8" v-if="item.yn === 'Y'" :key="'file' + i">
            <v-col cols="12" style="font-weight: bold;">
              {{ $t(item.value) }}</v-col
            >
            <v-col cols="12" class="mt-2 btn-post-wrap">
              <CVFileUpload
                :label="getLabel(item.limit)"
                :sectionKey="'file' + (i + 1)"
                :existingFileId="item.id"
                :isReadonly="isReadonly"
                :maxSize="item.limit"
                @upload="uploadFile"
                @delete="deleteFile"
              ></CVFileUpload>
            </v-col>
          </v-row>
        </template>
      </v-form>
    </div>
  </div>
</template>

<script>
import CVFileUpload from './CVFileUpload.vue';
import { snack } from '@/plugins/dialog/api';

export default {
  props: {
    template: { type: Object },
    info: { type: Object },
    opts: { type: Object },
    rules: { type: Object },
    isReadonly: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
  },
  components: {
    CVFileUpload,
  },
  mounted() {
    this.setting();
  },
  data: () => ({
    fileInfos: [],
    alert: false,
  }),
  methods: {
    setting: function() {
      this.file = [];
      for (let i = 1; i <= 10; i++) {
        let preName = 'file' + i;
        let lengthNm = preName + 'Length';
        let ynNm = preName + 'Yn';

        let obj = {
          value: this.opts[preName] ? this.template[preName] : '',
          limit: this.template[lengthNm] ? this.template[lengthNm] : 2,
          yn: this.template[ynNm] ? this.template[ynNm] : 'N',
          name: preName,
          id: this.desc(preName),
        };

        this.fileInfos.push(obj);
      }
    },
    desc: function(preName) {
      let id = '';
      if (this.info && this.info.files && this.info.files.length > 0) {
        this.info.files.forEach(function(v) {
          if (v.id.cvColumn === preName) id = v.fileId;
        });
      }

      return id;
    },
    getLabel: function(length) {
      return (
        this.$t('첨부 가능한 최대 파일사이즈는') + length + this.$t('MB입니다.')
      );
    },
    valid: function() {
      return this.$refs.form.validate();
    },
    save: function(i) {
      const id = {
        annoId: decodeURIComponent(this.$route.params.annoId),
        cvColumn: this.fileInfos[i].name,
      };

      const p = {
        id: id,
        fileId: this.fileInfos[i].id,
      };

      this.$emit('save', p, 'file');
    },
    savecallback: function(res) {
      if (res.status !== 200) {
        console.log('FILE INFO SAVE FAIL');
      } else {
        snack.info(
          `${this.$t(this.template.fileTitle)}` +
            this.$t('이 저장 되었습니다.'),
        );
      }
    },
    delete: function(i) {
      const p = {
        annoId: decodeURIComponent(this.$route.params.annoId),

        cvColumn: this.fileInfos[i].name,
      };
      this.$emit('delete', p, 'file', i);
    },
    deletecallback: function(res, i) {
      if (res.status !== 200) {
        console.log('FILE INFO DELETE FAIL');
      } else {
        this.fileInfos[i].id = null;
        snack.danger('삭제되었습니다.');
      }
    },
    uploadFile: function(sectionKey, fileId) {
      var seq = sectionKey.substring('file'.length, sectionKey.length);
      var idx = Number(seq) - 1;
      this.fileInfos[idx].id = fileId;
      if (idx !== -1) this.save(idx);
    },
    deleteFile: function(sectionKey) {
      var seq = sectionKey.substring('file'.length, sectionKey.length);
      var idx = Number(seq) - 1;
      if (idx !== -1) this.delete(idx);
    },
  },
};
</script>

<style>
.v-parallax {
  height: 100% !important;
}
.guide-common {
  min-height: calc(100vh - 64px - 122px);
}

.item-common .header .title {
  font-size: 18px;
  font-weight: bold;
  line-height: 2.67;
  letter-spacing: -0.36px;
  color: #292929;
}
.item-common .header .desc {
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: -0.28px;
  color: #555555;
}
.item-common .body {
  margin-top: 22px;
}
.item-common .body .v-divider {
  margin-top: 20px;
  margin-bottom: 20px;
}

.item-common .row {
  margin: 0px;
}
.item-common .col {
  padding: 0px;
}
.item-common .v-text-field {
  min-height: 36px;
}
.btn-post-wrap {
  position: relative;
}
.btn-post {
  position: absolute;
  top: 6px;
  right: 5px;
}
</style>
